export const getApiUrl = (path: string) => `${process.env.NEXT_PUBLIC_KEY}/${path}`
